import { Component, Inject, OnInit } from '@angular/core';
import { ManageSuppliersService } from '../../../../shared/services/manage-suppliers-service/manage-suppliers.service';
import { ModalData, ModalRef } from '@purespectrum1/ui/modal';
import {
  FlexibilityType,
  GetSupplierBlendInterface,
} from '../../../../shared/interfaces/survey.interface';
import { SupplierResponseInterface } from '../../../../shared/interfaces/survey.interface';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { UpdateSupplierBlendReq } from '../../../../shared/services/manage-suppliers-service/manage-suppliers.interface';
import { notifyMessage } from '../../../../shared/constants/notify-message';

export interface BlendModalData {
  suppliers: SupplierResponseInterface[];
  blendFlexibility: number;
  flexibilitySelectedType: FlexibilityType;
}

@Component({
  selector: 'ps-ui-blend-modal',
  templateUrl: './blend-modal.component.html',
  styleUrls: ['./blend-modal.component.css'],
})
export class BlendModalComponent implements OnInit {
  public title: string = '';
  public is_default: boolean = false;
  public suppliers: SupplierResponseInterface[] = [];
  public isDefaultChanged: boolean = false;
  public blendFlexibility: number;
  public flexibilitySelectedType: FlexibilityType;

  constructor(
    @Inject(ModalData) private _modalData: BlendModalData,
    private _modalRef: ModalRef<BlendModalComponent, GetSupplierBlendInterface>,
    private _manageSuppliersService: ManageSuppliersService,
    private _toaster: ToasterService
  ) {}

  ngOnInit(): void {
    this.suppliers = this._modalData.suppliers;
    this.blendFlexibility = this._modalData.blendFlexibility;
    this.flexibilitySelectedType = this._modalData.flexibilitySelectedType;
  }

  private _isTitleValid() {
    const {
      errorMessage: {
        SUPPLIER_BLEND: { TITLE_REQUIRED, TITLE_INVALID },
      },
    } = notifyMessage;
    const regexSpecialChars = /^[-@_\w\s]+$/;
    const hasOnlyValidChars = regexSpecialChars.test(this.title);

    if (!this.title) {
      this._toaster.error(TITLE_REQUIRED);
      return false;
    } else if (!hasOnlyValidChars) {
      this._toaster.error(TITLE_INVALID);
      return false;
    }
    return true;
  }

  save() {
    const blend = this._mapSuppliersToBlend(
      this.blendFlexibility,
      this.title,
      this.is_default,
      this.flexibilitySelectedType
    );
    if (!this._isTitleValid()) {
      return;
    }

    const successHandler = (newBlend: UpdateSupplierBlendReq) => {
      this._toaster.success('Success');
      this._modalRef.close(newBlend as unknown as GetSupplierBlendInterface);
    };
    const errorHandler = (error: any) => {
      this._toaster.error(error?.error?.msg || error.message);
    };

    this._manageSuppliersService
      .createSupplierBlends(blend)
      .subscribe(successHandler, errorHandler);
  }

  private _mapSuppliersToBlend(
    blendFlexibility: number,
    configName: string,
    isDefault: boolean,
    flexibilitySelectedType: FlexibilityType
  ) {
    return {
      blend_flexibility: blendFlexibility,
      config_name: configName,
      is_default: isDefault,
      flexibilitySelectedType,
      suppliers: this.suppliers
        .filter((s) => s.quantity >= 0 || s.suppliers.length > 1)
        .map(({ group_name, percentile, flexValue, suppliers }) => ({
          group_name: group_name || '',
          allocation_percentage: percentile,
          flexibility_percentage: flexValue,
          supplier_id: suppliers.map((supplier) => {
            return { id: supplier.id, allocation: supplier.allocation };
          }),
          id: suppliers[0].id,
        })),
    };
  }
}
